import React from 'react';
import './TeamCarousel.css';
import user1 from '../../Assets/leadership/team-1.png';
import user2 from '../../Assets/leadership/team-2.png';
import user3 from '../../Assets/leadership/team-3.png';
import user4 from '../../Assets/leadership/team-4.png';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';


const teamData = [
  {
    name: "Ms. Aruna Menon",
    title: "Chief Strategy Officer",
    description: "A visionary in enterprise transformation and new market entry.",
    quote: "Strategy without purpose is noise.",
    image: user1,
  },
  {
    name: "Ms. Aruna Menon",
    title: "Chief Strategy Officer",
    description: "A visionary in enterprise transformation and new market entry.",
    quote: "Strategy without purpose is noise.",
    image: user2,
  },
  {
    name: "Ms. Aruna Menon",
    title: "Chief Strategy Officer",
    description: "A visionary in enterprise transformation and new market entry.",
    quote: "Strategy without purpose is noise.",
    image: user3,
  },
  {
    name: "Ms. Aruna Menon",
    title: "Chief Strategy Officer",
    description: "A visionary in enterprise transformation and new market entry.",
    quote: "Strategy without purpose is noise.",
    image: user4,
  },
  {
    name: "Ms. Aruna Menon",
    title: "Chief Strategy Officer",
    description: "A visionary in enterprise transformation and new market entry.",
    quote: "Strategy without purpose is noise.",
    image: user1,
  },
  {
    name: "Ms. Aruna Menon",
    title: "Chief Strategy Officer",
    description: "A visionary in enterprise transformation and new market entry.",
    quote: "Strategy without purpose is noise.",
    image: user2,
  },
  {
    name: "Ms. Aruna Menon",
    title: "Chief Strategy Officer",
    description: "A visionary in enterprise transformation and new market entry.",
    quote: "Strategy without purpose is noise.",
    image: user3,
  },
  {
    name: "Ms. Aruna Menon",
    title: "Chief Strategy Officer",
    description: "A visionary in enterprise transformation and new market entry.",
    quote: "Strategy without purpose is noise.",
    image: user4,
  }
];

const TeamCarousel = () => {
  const scrollRef = React.useRef();

  const scrollLeft = () => {
    if (scrollRef.current) scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = () => {
    if (scrollRef.current) scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
  };

  return (
    <div className="carousel-wrapper">
      <button className="carousel-arrow left" onClick={scrollLeft}><FaChevronLeft /></button>
      
      <div className="team-card-carousel" ref={scrollRef}>
        {teamData.map((member, index) => (
          <div key={index} className="team-card-box">
            <div className="team-card-inner">
              <img src={member.image} alt={member.name} className="team-card-image" />
              <h3 className="team-card-name">{member.name}</h3>
              <p className="team-card-title">{member.title}</p>
              <p className="team-card-description">{member.description}</p>
              <p className="team-card-quote">{member.quote}</p>
              <a href="#" className="team-card-linkedin">LinkedIn</a>
            </div>
          </div>
        ))}
      </div>

      <button className="carousel-arrow right" onClick={scrollRight}><FaChevronRight /></button>
    </div>
  );
};

export default TeamCarousel;
